import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnDestroy,
} from "@angular/core";
import {AuthService} from "../../services/auth.service";
import {CustomError} from "src/app/modules/shared/interfaces/CustomError.interface";
import {
  FormBuilder,
  FormGroup,
  Validators,
  FormsModule,
  ReactiveFormsModule,
} from "@angular/forms";
import {Subscription} from "rxjs";
import {TranslateService, TranslateModule} from "@ngx-translate/core";

@Component({
  selector: "app-account-activation-form",
  templateUrl: "./account-activation-form.component.html",
  styleUrls: ["./account-activation-form.component.css"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [FormsModule, ReactiveFormsModule, TranslateModule],
})
export class AccountActivationFormComponent implements OnDestroy {
  activationForm: FormGroup;
  activationSent = false;
  error!: CustomError;
  private readonly userLanguage = navigator.language.startsWith("fr")
    ? "fr"
    : "en";
  private readonly subscriptions: Subscription[] = [];

  constructor(
    private readonly translate: TranslateService,
    private readonly formBuilder: FormBuilder,
    private readonly authService: AuthService,
    private readonly cdr: ChangeDetectorRef
  ) {
    this.activationForm = this.formBuilder.group({
      email: ["", [Validators.required, Validators.email]],
    });

    this.translate.defaultLang = this.userLanguage;
    this.translate.reloadLang(this.userLanguage);
    this.translate.use(this.userLanguage);
  }

  onSubmit() {
    if (this.activationForm.invalid) {
      this.error = {
        error: {
          error: "FILL_ALL_FIELDS",
        },
      };
      return;
    }

    const sendActivationEmailSubscription = this.authService
      .sendActivationEmail(this.activationForm.value.email)
      .subscribe({
        next: () => {
          this.activationSent = true;
          this.cdr.markForCheck();
        },
        error: (error: CustomError) => {
          this.error = error;
          this.cdr.markForCheck();
        },
      });
    this.subscriptions.push(sendActivationEmailSubscription);
  }

  ngOnDestroy() {
    for (const sub of this.subscriptions) {
      sub.unsubscribe();
    }
  }
}
